import {useCheckToken} from '../context/useMutation'

const Base = ({children}) => {
  useCheckToken()

  return <>{children}</>
}

export default Base
